import { inject, injectable } from 'inversify';
import type { ClientGameRepositoryInterface } from '@client/entity/client-game/domain/repository/client-game.repository';
import { ClientGameDependencyTypes } from '@client/entity/client-game/client-game.dependency-types';
import type { ClientGameApiDataTransformer } from '@client/entity/client-game/data/transformer/client-game.api-data-transformer';
import type { ClientGameApiService } from '@client/entity/client-game/data/service/client-game.api-service';
import type { ClientGame } from '@client/entity/client-game/domain/model/client-game.model';
import { wrapCockpitApiError } from '@shared/common/error/data/service/wrap-cockpit-api-error.service';
import { dispatchAuthenticationRequiredOnApiError } from '@shared/common/network/data/service/dispatch-authentication-required-on-api-error.service';

@injectable()
export class ClientGameRepository implements ClientGameRepositoryInterface {
  public constructor(
    @inject(ClientGameDependencyTypes.ClientGameApiService)
    private readonly apiService: ClientGameApiService,
    @inject(ClientGameDependencyTypes.ClientGameApiDataTransformer)
    private readonly clientGameApiDataTransformer: ClientGameApiDataTransformer,
  ) {}

  @wrapCockpitApiError()
  @dispatchAuthenticationRequiredOnApiError()
  public async fetchClientGames(clientId: string): Promise<ClientGame[]> {
    const response = await this.apiService.getClientGames(clientId);

    return this.clientGameApiDataTransformer.mapItems(response.data);
  }
}
